import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
  CustomFormControl,
  CustomTextField,
} from './FsOutlinedSearch.style-elements';

interface FsOutlinedSearchProps {
  value: string;
  label?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<{ value: string }>) => void;
}

const FsOutlinedSearch: React.FC<FsOutlinedSearchProps> = ({
  name,
  value,
  label,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<{ value: string }>): void => {
    if (onChange) onChange(event);
  };

  return (
    <CustomFormControl variant="outlined">
      <CustomTextField
        name={name}
        fullWidth
        size="small"
        onChange={handleChange}
        value={value}
        variant="outlined"
        label={label}
        InputProps={{
          startAdornment: <SearchIcon />,
        }}
      />
    </CustomFormControl>
  );
};

export default FsOutlinedSearch;
